import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col w-full"
}
const _hoisted_2 = { class: "h3 mt-4 mb-4 flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mr-4" }, "Wybór Ieku", -1)
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { useField, useFieldArray } from 'vee-validate';
import Search from './components/Search.vue';
import MedicationItem from './components/MedicationItem.vue';
import TooltipButton from '../TooltipButton.vue';


export default {
  __name: 'MedicationChoose',
  setup(__props) {

const { errors, errorMessage } = useField('selectedMedications');

const { value } = useField('receiptPlan');

const { remove, fields, push } = useFieldArray('selectedMedications');

return (_ctx, _cache) => {
  return (_unref(value) === 'own')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, [
          _hoisted_3,
          _createVNode(TooltipButton, null, {
            default: _withCtx(() => []),
            tooltip: _withCtx(() => [
              _createTextVNode("W ramach konsultacji można wnioskować o 1 Iek")
            ]),
            _: 1
          })
        ]),
        _createVNode(Search, {
          onAddItem: _unref(push),
          hasErrors: !!_unref(errors).length,
          selectedMedications: _unref(fields)
        }, null, 8, ["onAddItem", "hasErrors", "selectedMedications"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, idx) => {
          return (_openBlock(), _createBlock(MedicationItem, {
            id: idx,
            field: field.value,
            key: field.key,
            onRemoveItem: _unref(remove)
          }, null, 8, ["id", "field", "onRemoveItem"]))
        }), 128)),
        (_unref(errorMessage))
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

}